import { Feature, LineString, Properties } from "@turf/turf";

import { ITravelMarker } from "shared/types";
import { getCurvedLine } from "./getCurvedLine";

export const mapMarkersToLines = (
  markers: ITravelMarker[]
): GeoJSON.FeatureCollection<GeoJSON.LineString> => {
  const features: Feature<LineString, Properties>[] = [];

  markers.forEach((marker, index) => {
    // draw lines between marker.0 and marker.1
    // marker.2 and marker.3
    // marker.4 and marker.5
    // etc.
    // starting from marker.0, marker.2, marker.4 etc.
    if (index % 2 !== 0) return;

    // don't draw line FROM last marker
    if (index >= markers.length - 1) return;

    features.push({
      ...getCurvedLine({
        start: marker.coordinates,
        end: markers?.[index + 1].coordinates,
      }),
      id: marker.id,
      properties: {
        id: marker.id,
        departure: marker.departure,
        arrival: marker.arrival,
      },
    });
  });

  return {
    type: "FeatureCollection",
    features,
  };
};
